import { render, staticRenderFns } from "./ProdPreviewModal.vue?vue&type=template&id=a4592428&"
import script from "./ProdPreviewModal.vue?vue&type=script&lang=js&"
export * from "./ProdPreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports